<template>
    <div v-if="setting_status != 'loading'">
        <form id="card_to_card_settings_form" class="bg-white p-3 rounded">
            <kt-row>
                <kt-col xs="12" sm="6" lg="6">
                    <div v-for="(card_setting , index) in setting" v-bind:key="index">
                        <div class="container p-3 pt-5 my-4 border in-border-header">
                            <div class="section-header">
                                {{ card_setting.card_number }}
                            </div>
                            <kt-col xs="12">
                                <kt-form-group>
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            :id="'is_count_limited'+index"
                                            :name="'is_count_limited'+index"
                                            v-model="card_setting.is_count_limited"
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                    <label
                                        :for="'is_count_limited'+index"
                                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                                    >
                                        {{ $t('card_to_card.is_count_limited') }}
                                    </label>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" v-if="card_setting.is_count_limited">
                                <kt-form-group>
                                    <kt-form-label for="count_limit">
                                        {{ $t('card_to_card.count_limit') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :id="'count_limit'+index"
                                        type="number"
                                        :name="'count_limit'+index"
                                        v-model="card_setting.count_limit"
                                        dir="ltr"
                                    >
                                    </kt-form-control>
                                    <p :id="'count_limit_error'+index"
                                       style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" style="margin-top: 35px">
                                <kt-form-group>
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            :id="'is_amount_limited'+index"
                                            :name="'is_amount_limited'+index"
                                            v-model="card_setting.is_amount_limited"
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                    <label
                                        :for="'is_amount_limited'+index"
                                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                                    >
                                        {{ $t('card_to_card.is_amount_limited') }}
                                    </label>
                                </kt-form-group>
                            </kt-col>
                            <kt-col xs="12" v-if="card_setting.is_amount_limited">
                                <kt-form-group>
                                    <kt-form-label for="amount_limit">
                                        {{ $t('card_to_card.amount_limit') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :id="'amount_limit'+index"
                                        type="number"
                                        :name="'amount_limit'+index"
                                        v-model="card_setting.amount_limit"
                                        dir="ltr"
                                    >
                                    </kt-form-control>
                                    <p :id="'amount_limit_error'+index"
                                       style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                                </kt-form-group>
                            </kt-col>
                        </div>
                    </div>
                </kt-col>
                <kt-col xs="12" sm="6" lg="6">
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <div class="section-header">
                            {{ $t('card_to_card.card_prioritize') }}
                        </div>
                        <kt-col xs="12" v-for="(priority , index) in priorities" v-bind:key="index">
                            <kt-form-group v-if="index != 0">
                                <kt-form-label>
                                    {{ $t('label.priority') + (index) }}
                                </kt-form-label>
                                <kt-form-select
                                    size="3"
                                    :id="'priority'+index"
                                    :name="'priority'+index"
                                    v-model="priorities[index]"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(card, index) in setting"
                                        v-bind:value="card.card_number"
                                    >
                                        {{ card.card_number }}
                                    </option>
                                </kt-form-select>
                                <p :id="'priority_error'+index"
                                   style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                            </kt-form-group>
                        </kt-col>
                    </div>
                </kt-col>
            </kt-row>
            <kt-form-action class="mt-4" style="margin-top: 20px!important;text-align: end!important;">
                <kt-button
                    class="btn-wide"
                    type="button"
                    size="md"
                    @click="edit"
                    variant="success"
                    v-bind:wide="true"
                    id="card_to_card_settings_btn"
                >
                    {{ $t('btn.edit') }}
                </kt-button>
            </kt-form-action>
        </form>
        <!--        <kt-form-action v-if="card_to_card.need_credit && card_to_card.status == cardToCardStatus.ACTIVE">-->
        <!--            <charge-monthly-credit></charge-monthly-credit>-->
        <!--        </kt-form-action>-->
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {cardToCardService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';
import toastr from "toastr";
import {mapGetters} from "vuex";

export default {
    components: {},
    props: {
        card_to_card: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            priority_count: 0,
            priorities: [],
        }
    },
    mounted() {
        this.$store.dispatch('cardToCard/fetchSetting', this.card_to_card.id)
        this.afterDispatch()
    },
    computed: {
        ...mapGetters('cardToCard', [
            'setting', 'setting_status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    watch: {
        setting_status: {
            handler(newValue, oldValue) {
                if (newValue == 'success')
                    this.setPriorities()
            },

        },
    },
    methods: {
        edit() {
            let btn = $('#card_to_card_settings_btn')
            let form = $('#card_to_card_settings_form')

            let has_error = false
            for (let i = 0; i < this.setting.length; i++) {
                if (this.setting[i].is_count_limited) {
                    if (!this.setting[i].count_limit) {
                        document.getElementById('count_limit_error' + i).innerText = i18n.t('card_to_card.message.fill')
                        document.getElementById('count_limit' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else {
                        document.getElementById('count_limit_error' + i).innerText = ''
                        document.getElementById('count_limit' + i).style.borderColor = '#e2e5ec'
                    }
                }
                if (this.setting[i].is_amount_limited) {
                    if (!this.setting[i].amount_limit) {
                        document.getElementById('amount_limit_error' + i).innerText = i18n.t('card_to_card.message.fill')
                        document.getElementById('amount_limit' + i).style.borderColor = '#fd397a'
                        has_error = true;
                    } else {
                        document.getElementById('amount_limit_error' + i).innerText = ''
                        document.getElementById('amount_limit' + i).style.borderColor = '#e2e5ec'
                    }
                }
            }

            for (let i = 1; i < this.priorities.length; i++) {
                if (!this.priorities[i]) {
                    document.getElementById('priority_error' + i).innerText = i18n.t('card_to_card.message.fill')
                    document.getElementById('priority' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    let duplicate_priority = false
                    for (let j = 1; j < this.priorities.length; j++) {
                        if (this.priorities[i] == this.priorities[j] && j != i) {
                            duplicate_priority = true;
                            break;
                        }
                    }
                    if (duplicate_priority) {
                        has_error = true
                        document.getElementById('priority_error' + i).innerText = i18n.t('card_to_card.message.duplicate_priority')
                        document.getElementById('priority' + i).style.borderColor = '#fd397a'
                    } else {
                        document.getElementById('priority_error' + i).innerText = ''
                        document.getElementById('priority' + i).style.borderColor = '#e2e5ec'
                    }
                }
            }
            if (has_error)
                return;
            for (let i = 0; i < this.setting.length; i++) {
                for (let j = 1; j < this.priorities.length; j++) {
                    if (this.setting[i].card_number == this.priorities[j]) {
                        this.setting[i].priority = j;
                    }
                }
            }
            KTApp.progress(btn)
            let params = {
                cards_setting: this.setting
            }
            cardToCardService.updateSetting(params, this.$route.params.hashid).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTUtil.scrollTop();
                KTApp.unprogress(btn)
            })
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setPriorities() {
            this.priority_count = this.setting.length
            let priorities = []
            priorities[0] = null

            for (let i = 1; i <= this.priority_count; i++) {
                for (let j = 0; j < this.priority_count; j++) {
                    priorities[i] = null
                    if (this.setting[j].priority == i) {
                        priorities[i] = this.setting[j].card_number
                        break;
                    }
                }
            }
            this.priorities = priorities
        }
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture {
    width: 50%;
    height: 150px;
}

.remove_picture {
    cursor: pointer;
    position: absolute;
    top: -5px;
}
</style>